<h3 class="title-divider">
  {{ "ErgebnisoptionenEigentum" | translate }}
</h3>
<fieldset [disabled]="disabled">
  <cap-form-control labelKey="EigentumExportieren">
    <input
      (ngModelChange)="model && (model.eigentum = $event)"
      [ngModel]="model && model.eigentum"
      name="eigentumExportieren"
      type="checkbox" />
  </cap-form-control>
  <div class="ms-4">
    <cap-form-control labelKey="Datenschutzbereinigt">
      <input
        (ngModelChange)="model && (model.datenschutzbereinigt = $event)"
        [disabled]="model && !model.eigentum"
        [ngModel]="model && model.datenschutzbereinigt"
        name="datenschutzbereinigt"
        type="checkbox" />
    </cap-form-control>
  </div>
</fieldset>
